import React from 'react';
import Icon from '@ant-design/icons';

const svg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M14.6693 1.33325L7.33594 8.66659"
      stroke="currentColor"
      strokeWidth="1.33"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6693 1.33325L10.0026 14.6666L7.33594 8.66659L1.33594 5.99992L14.6693 1.33325Z"
      stroke="currentColor"
      strokeWidth="1.33"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SendIcon2 = (props) => <Icon component={svg} {...props} />;

export default SendIcon2;
